import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { removeEntity } from 'actions/livefeed'

const DeleteOptionButton = (props) => {
    const { currentEntity, dispatch } = props;

    const activeToolbarItems = currentEntity !== undefined && currentEntity.activeToolbarItems;
    const isDeleteable = currentEntity !== undefined && (currentEntity.id !== null && activeToolbarItems[1].deletable);

    const deleteHandle = useCallback(() => {
        dispatch(removeEntity(currentEntity.id))
    }, [currentEntity.id, dispatch])

    return (
        <div className={`icon-wrapper justify-center icon-wrapper_delete  ${isDeleteable ? '' : 'icon-wrapper_disable'}`}
            onClick={() => isDeleteable ? deleteHandle() : undefined}>
            <i data-tooltip="Delete" style={{ fontSize: "32px" }} className="material-icons">delete_forever</i>
        </div>
    );
}
DeleteOptionButton.propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentEntity: PropTypes.object.isRequired
}
export default DeleteOptionButton;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/DeleteOptionButton.jsx